import { Alert, Alignment, Button, Classes, Dialog, FormGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { formatCnpj } from "../../utils";
import { Pager } from "../utils/Pager";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { RelatorioParcelamentoStore } from "../../stores/relatorio/RelatorioParcelamentoStore";

@observer
export class RelatorioParcelamentoPage extends React.Component<{}, {}> {

  obs = observable({
    date_periodo_relatorio: [] as any,
    current_page: 1 as number,
    erros_relatorio: [] as any,

    filtro_tipoParcela: 0 as number,
    filtro_tipo: "" as string,
    filtro_empresa: newEmpresa(),
    filtro_date_start: "" as string,
    filtro_date_end: "" as string,

    modal_tipo_parcela: 0 as number,
    modal_tipo: "" as string,
    modal_empresa: newEmpresa(),
    // modal_date_start: "" as string,
    // modal_date_end: "" as string,
    modal_situacao: "Todas" as string
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("Relatório de parcelamentos");
    RelatorioParcelamentoStore.handleTasksPaged(1)
  }

  /**
   * Executa o fluxo de criação de relatório de parcelamento.
   *
   * Este método:
   *  - Lê os dados selecionados no modal (empresa, tipo, situação, etc.)
   *  - Solicita a geração do relatório ao `RelatorioParcelamentoStore`
   *  - Atualiza a listagem de tarefas paginadas
   *  - Fecha o modal após a execução
   *
   * Parâmetros utilizados:
   *  - `emp.cnpj` - CNPJ da empresa selecionada no modal.
   *  - `this.obs.modal_tipo_parcela` - Tipo da parcela selecionada.
   *  - `this.obs.modal_tipo` - Tipo do relatório.
   *  - `this.obs.modal_situacao` - Situação/Status a ser filtrado.
   *
   * Métodos envolvidos:
   *  - `RelatorioParcelamentoStore.handleSolicitarRelatorio`
   *    Envia a solicitação de criação do relatório ao backend.
   *
   *  - `RelatorioParcelamentoStore.handleTasksPaged(page: number)`
   *    Atualiza a listagem de tarefas, retornando a página especificada.
   *
   * @async
   * @returns {Promise<void>} Promessa concluída após o processamento.
  */

  async handleCreateRelatorio() {
    const emp = this.obs.modal_empresa;

    // if (!emp.cnpj) {
    //   toast.warning("Você precisa selecionar uma Empresa.");
    //   return;
    // }

    // if (!this.obs.modal_date_start || this.obs.modal_date_start === "Data inválida") {
    //   toast.warning("Você precisa selecionar uma Data válida.");
    //   return;
    // }

    // if (!this.obs.modal_date_end || this.obs.modal_date_end === "Data inválida") {
    //   toast.warning("Você precisa selecionar uma Data válida.");
    //   return;
    // }

    // RelatorioParcelamentoStore.handleSolicitarRelatorio(emp.cnpj, this.obs.modal_tipo_parcela, this.obs.modal_tipo, this.obs.modal_date_start, this.obs.modal_date_end, this.obs.modal_situacao);

    RelatorioParcelamentoStore.handleSolicitarRelatorio(emp.cnpj, this.obs.modal_tipo_parcela, this.obs.modal_tipo, this.obs.modal_situacao);

    await RelatorioParcelamentoStore.handleTasksPaged(1);

    this.onClose();

  }

  /**
   * Trunca um texto para exibição e mostra o conteúdo completo em um tooltip.
   *
   * Caso o texto ultrapasse o limite informado, ele é cortado e recebe "..." ao final.
   * O texto completo é mantido no atributo `title`, permitindo que o usuário veja o
   * conteúdo original ao passar o mouse sobre o texto.
   *
   * Uso típico:
   *  - Exibição de textos longos em colunas de tabela.
   *  - Campos que não devem quebrar o layout, mas cujo conteúdo completo ainda
   *    precisa estar acessível.
   *
   * @param {string} text
   *   Texto original a ser exibido/truncado.
   *
   * @param {number} [limit=30]
   *   Quantidade máxima de caracteres a serem exibidos antes de aplicar o truncamento.
   *   Valor padrão: 30.
   *
   * @returns {string}
   *   - Retorna uma `<span>` com o texto truncado e o `title` com o texto completo, quando `text` é informado.
   *   - Retorna string vazia (`""`) quando `text` é falsy (null, undefined, etc.).
  */
  
  truncateWithTooltip = (text: string, limit: number = 30) => {
    if (!text) return "";

    const truncated = text.length > limit ? text.substring(0, limit) + "..." : text;

    return (
      <span title={text} style={{ cursor: "help" }}>
        {truncated}
      </span>
    );
  };

  /**
   * Atualiza a página atual da listagem de relatórios e recarrega os dados.
   *
   * Esta função:
   *  - Atualiza o estado `current_page` com a página informada.
   *  - Chama `RelatorioParcelamentoStore.handleTasksPaged` para buscar os dados
   *    da página selecionada, aplicando os filtros atuais.
   *
   * Filtros enviados para o store:
   *  - `cnpj`: CNPJ da empresa selecionada no filtro (`this.obs.filtro_empresa.cnpj`), ou string vazia caso não haja empresa selecionada.
   *  - `tipo_p`: Tipo de parcela filtrado (`this.obs.filtro_tipoParcela`).
   *  - `tipo_s`: Tipo de relatório/solicitação filtrado (`this.obs.filtro_tipo`).
   *
   * @param {number} page
   *   Número da página que deve ser carregada na listagem.
   *
   * @async
   * @returns {Promise<void>}
   *   Promessa resolvida após a atualização da página e recarregamento dos dados.
  */

  async handleChangePage(page: number) {
    this.obs.current_page = page
    await RelatorioParcelamentoStore.handleTasksPaged(this.obs.current_page, {
      cnpj: this.obs.filtro_empresa.cnpj || "",
      tipo_p: this.obs.filtro_tipoParcela,
      tipo_s: this.obs.filtro_tipo
    });
  }

  // handleDateSolicitacaoChange = (val: any) => {
  //   var array = val.toString().split(",");

  //   this.obs.modal_date_start = moment(array[0]).format("YYYY-MM-DD");
  //   this.obs.modal_date_end = moment(array[1]).format("YYYY-MM-DD");

  //   this.obs.date_periodo_relatorio = val;
  // };

  /**
   * Realiza a busca inicial dos relatórios de parcelamento aplicando os filtros atuais.
   *
   * Esta função:
   *  - Lê os filtros da tela (empresa, tipo de parcela e tipo de relatório).
   *  - Chama `RelatorioParcelamentoStore.handleTasksPaged` sempre na página 1,
   *    reiniciando a paginação a cada nova busca.
   *
   * Filtros utilizados:
   *  - `empresa?.cnpj`: CNPJ da empresa selecionada no filtro.
   *    - Caso nenhuma empresa esteja selecionada, envia string vazia (`""`).
   *  - `tipo_p`: Tipo de parcela selecionado (`this.obs.filtro_tipoParcela`).
   *  - `tipo_s`: Tipo de solicitação/relatório (`this.obs.filtro_tipo`).
   *
   * Comportamento:
   *  - Atualiza a listagem de tarefas/relatórios para a página 1,
   *    respeitando os filtros informados.
   *
   * @async
   * @returns {Promise<void>}
   *   Retorna carregamento dos dados filtrados.
  */

  handleBuscar = async () => {
    const empresa = this.obs.filtro_empresa;
    const tipo_p = this.obs.filtro_tipoParcela;
    const tipo_s = this.obs.filtro_tipo;

    await RelatorioParcelamentoStore.handleTasksPaged(1, { cnpj: empresa?.cnpj || "", tipo_p, tipo_s });
  };

  /**
   * Fecha o modal de criação de relatório de parcelamento e reseta os campos do formulário.
   *
   * Esta função:
   *  - Fecha o modal inicial de relatório (`RelatorioParcelamentoStore.obs.open_initial = false`).
   *  - Limpa/resseta os campos utilizados no modal, preparando o estado
   *    para uma nova abertura.
   *
   * Campos resetados:
   *  - `this.obs.date_periodo_relatorio`:
   *      - Limpo para um array vazio `[]`.
   *  - `this.obs.modal_empresa`:
   *      - Redefinido chamando `newEmpresa()`, restaurando o objeto padrão de empresa.
   *  - `this.obs.modal_tipo_parcela`:
   *      - Redefinido para `0` (valor inicial).
   *  - `this.obs.modal_tipo`:
   *      - Redefinido para string vazia `""`.
   *  - `this.obs.modal_situacao`:
   *      - Redefinido para `"Todas"`, indicando que nenhuma situação específica está filtrada.
  */

  onClose() {
    RelatorioParcelamentoStore.obs.open_initial = false;

    this.obs.date_periodo_relatorio = [];
    this.obs.modal_empresa = newEmpresa();
    this.obs.modal_tipo_parcela = 0;
    this.obs.modal_tipo = "";
    // this.obs.modal_date_start = "";
    // this.obs.modal_date_end = "";
    this.obs.modal_situacao = "Todas";
  }

  /**
   * Trata a lista de erros retornada na geração de relatório e exibe o modal de erros.
   *
   * A função recebe uma string com erros concatenados por vírgula,
   * transforma em uma lista estruturada e armazena em `this.obs.erros_relatorio`.
   * Em seguida, abre o modal de exibição de erros.
   *
   * Formato de entrada esperado:
   *  - `error`: string contendo mensagens de erro separadas por vírgula.
   *    Exemplo: `"Erro na linha 1,Erro na linha 2,Erro na linha 3"`
   *
   * Comportamento:
   *  1. Divide a string `error` em um array usando `split(",")`.
   *  2. Mapeia cada erro para um objeto.
   *  3. Atribui o array resultante em `this.obs.erros_relatorio`.
   *  4. Define `RelatorioParcelamentoStore.obs.open_erros_relatorio = true`
   *     para abrir o modal/listagem de erros no front.
   *
   * @param {string} error
   *   String contendo as mensagens de erro separadas por vírgula.
  */

  handleErrosRelatorio(error: string) {
    let list_erros = error.split(",")
    this.obs.erros_relatorio = list_erros.map((x, index) => ({
      id: index + 1,
      erros: x
    }));

    RelatorioParcelamentoStore.obs.open_erros_relatorio = true
  }

  /**
   * Fecha o modal de erros do relatório e limpa a lista de erros exibidos.
   *
   * Esta função:
   *  - Define `RelatorioParcelamentoStore.obs.open_erros_relatorio` como `false`,
   *    fechando o modal de exibição de erros.
   *  - Limpa o array `this.obs.erros_relatorio`, removendo todos os erros
   *    previamente carregados.
   *
   * Uso típico:
   *  - Acionado ao clicar no botão "Fechar" / "Ok" do modal de erros de relatório.
   *  - Garante que, ao reabrir o modal futuramente, ele não exiba erros antigos.
  */

  onCloseErros() {
    RelatorioParcelamentoStore.obs.open_erros_relatorio = false
    this.obs.erros_relatorio = []
  }

  /**
   * Altera a categoria/tipo de parcelas utilizada no filtro e reseta o tipo de relatório.
   *
   * Esta função é chamada quando o usuário seleciona uma nova categoria de parcelas.
   *
   * Comportamento:
   *  - Converte o `value` recebido para número e atribui em `this.obs.filtro_tipoParcela`.
   *  - Reseta `this.obs.filtro_tipo` para string vazia (`""`), garantindo que qualquer tipo de relatório/solicitação anteriormente selecionado seja limpo ao mudar a categoria de parcelas.
   *
   * Efeito prático:
   *  - Evita combinação inconsistente entre “tipo de parcela” e “tipo de relatório”.
   *  - Obriga o usuário a selecionar novamente o tipo de relatório após alterar a categoria.
   *
   * @param {any} value
   *   Valor selecionado para o tipo de parcela.
   *   Será convertido para número ao ser atribuído em `filtro_tipoParcela`.
  */

  handleChangeCategoriaParcelas(value: any) {
    this.obs.filtro_tipoParcela = Number(value);
    this.obs.filtro_tipo = "";
  }

  /**
   * Altera a categoria/tipo de parcelas no modal de criação de relatório
   * e reseta os demais campos dependentes.
   *
   * Esta função é chamada quando o usuário seleciona uma nova categoria de parcelas
   * dentro do **modal** (ex.: seleção de "Tipo de Parcela" antes de solicitar o relatório).
   *
   * Comportamento:
   *  - Converte o `value` recebido para número e atribui em `this.obs.modal_tipo_parcela`.
   *  - Reseta `this.obs.modal_tipo` para string vazia (`""`), forçando nova escolha
   *    de tipo de relatório após a mudança da categoria.
   *  - Limpa o período de datas do relatório:
   *      - `this.obs.date_periodo_relatorio = []`
   *      - (Campos individuais de data `modal_date_start` e `modal_date_end`
   *         estão comentados, mas podem ser reativados se voltarem a ser usados.)
   *  - Redefine `this.obs.modal_situacao` para `"Todas"`, removendo qualquer filtro
   *    específico de situação previamente selecionado.
   *
   * @param {any} value
   *   Valor selecionado para o tipo de parcela no modal.
   *   Será convertido para número ao ser atribuído em `modal_tipo_parcela`.
  */

  handleChangeCategoriaParcelasModal(value: any) {
    this.obs.modal_tipo_parcela = Number(value);
    this.obs.modal_tipo = "";
    // this.obs.modal_date_start = "";
    // this.obs.modal_date_end = "";
    this.obs.date_periodo_relatorio = [];
    this.obs.modal_situacao = "Todas";
  }

  handleOpenParcelamentos() {

    window.open(`/parcelamentos`, "_blank")

  }

  /**
   * Retorna a descrição/label de um tipo de parcela a partir do seu código.
   *
   * A função percorre todas as categorias definidas em `this.tiposParcelasCategoria` e procura um item cujo `value` seja igual ao `codigo` informado. Caso encontre,
   * retorna o `label` correspondente. Se não encontrar o código em nenhuma categoria, retorna o próprio `codigo` recebido.
   *
   * Estrutura esperada de `this.tiposParcelasCategoria`:
   *  - Objeto onde cada chave representa uma categoria, e o valor é um array de tipos.
   *
   * @param {any} codigo
   *   Código do tipo de parcela que será buscado nas categorias.
   *   Normalmente corresponde ao `value` de um dos itens de `tiposParcelasCategoria`.
   *
   * @returns {string | any}
   *   - `label` associado ao código, caso seja encontrado.
   *   - Caso contrário, retorna o próprio `codigo` informado.
  */

  getTipoParcelas = (codigo) => {
    const categorias = this.tiposParcelasCategoria;

    for (const cat in categorias) {
      const tipos = categorias[cat];
      const found = tipos.find(t => t.value === codigo);
      if (found) return found.label;
    }
    return codigo;
  };

  /**
   * Mapa de categorias de tipos de parcelamento disponíveis no sistema.
   *
   * A chave do objeto representa o **código da categoria de parcelamento** (número),
   * enquanto o valor é um array de tipos específicos dessa categoria, cada um com:
   *  - `value`: código detalhado do tipo de parcelamento (string)
   *  - `label`: descrição legível para exibição na interface
   *
   * Este objeto é utilizado, por exemplo:
   *  - Para montar selects/combos dependentes de categoria.
   *  - Em helpers como `getTipoParcelas` para obter o rótulo/descrição
   *    a partir de um código.
  */

  tiposParcelasCategoria = {
    0: [],
    1: [],
    2: [
      { value: "2.1", label: "Simplificado" },
      { value: "2.2", label: "Não Previdenciário" },
    ],
    3: [
      { value: "3.1", label: "Parcelamento Lei 12.996/2014" },
      { value: "3.2", label: "Parcelamento Lei 11.941/2009" },
      { value: "3.3", label: "Previdenciário INSS" },
      { value: "3.4", label: "Previdenciário PERT" },
      { value: "3.5", label: "Especiais (Solicitar e Acompanhar)" },
    ],
    4: [
      { value: "4.1", label: "Parcelamento do Simples Nacional - Ordinário" },
      { value: "4.2", label: "Parcelamento do Simples Nacional - Especial" },
      { value: "4.3", label: "Programa Especial de Regularização Tributária do Simples Nacional" },
      { value: "4.4", label: "Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Simples Nacional" },
      { value: "4.5", label: "Parcelamento do Microempreendedor Individual - Ordinário" },
      { value: "4.6", label: "Parcelamento do Microempreendedor Individual - Especial" },
      { value: "4.7", label: "Programa Especial de Regularização Tributária do Microempreendedor Individual" },
      { value: "4.8", label: "Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Microempreendedor Individual" },
    ],
    5: [
      { value: "5.1", label: "PROREFIS" },
      { value: "5.2", label: "Acompanhar" },
    ],
  };

  render() {

    let empresaText = this.obs.filtro_empresa?.cnpj
      ? `${this.obs.filtro_empresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.filtro_empresa.cnpj)})`
      : "Selecione uma empresa";

    let empresaTextModal = this.obs.modal_empresa?.cnpj
      ? `${this.obs.modal_empresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.modal_empresa.cnpj)})`
      : "Selecione uma empresa (opcional)";

    function statusFormatter(cell, row) {

      return getTag(row.status, "relatorio");

    }

    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => RelatorioParcelamentoStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj, row.format)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const errosFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 3}
            onClick={() => this.handleErrosRelatorio(row.error)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const dateFormatterPeriodo = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY");
    };

    const razaoSocialFormatter = (cell, row) => {
      if(!row.razao_social) {

        return ("N/A")

      } else {

        return row.razao_social

      }
    }

    const cnpjFormatter = (cell, row) => {

      if(!row.cnpj) {

        return ("Todos")

      } else {

        return formatCnpj(row.cnpj)

      }

    };

    const categoriasParcelas = {
      0: "Todas",
      1: "PGFN",
      2: "RECEITA FEDERAL",
      3: "ESPECIAIS",
      4: "SIMPLES NACIONAL",
      5: "SEFA"
    };

    const categoriaFormatter = (cell, row) => {
      return categoriasParcelas[row.tipo_p] || row.tipo_p;
    };

    const tipoFormatter = (cell, row) => {
      const label = this.getTipoParcelas(row.tipo_s) || "Todas";
      return this.truncateWithTooltip(label, 35);
    };

    return (
      <>
        <MDBRow>
          <MDBCol md="4">
            <MDBRow>
              <MDBCol>
                <FormGroup className="empresaSelect" label="Empresa">
                  <EmpresaSelect
                    items={EmpresaStore.sortedEmpresas}
                    itemRenderer={renderEmpresa}
                    itemPredicate={filterEmpresa}
                    onItemSelect={(e: IEmpresa) => {
                      this.obs.filtro_empresa = e;
                    }}
                    inputProps={{ placeholder: "Filtrar uma empresa" }}
                  >
                    <Button
                      text={empresaText}
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                    />
                  </EmpresaSelect>
                </FormGroup>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="2">
            <FormGroup
              label="Categoria"
              className="nz-horizontal-field selectFullWidth"
              style={{ width: "100%" }}
            >
              <select
                value={this.obs.filtro_tipoParcela}
                onChange={(e) => this.handleChangeCategoriaParcelas(e.target.value)}
                className="bp3-button bp3-align-left"
              >
                <option value={0}>Todas</option>
                <option value={1}>PGFN</option>
                <option value={2}>RECEITA FEDERAL</option>
                <option value={3}>ESPECIAIS</option>
                <option value={4}>SIMPLES NACIONAL</option>
                <option value={5}>SEFA</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol md="4">
            <FormGroup label="Tipo parcelamento" className="empresaSelect">
              <select
                className="bp3-button bp3-align-left"
                disabled={this.obs.filtro_tipoParcela === 0 || this.obs.filtro_tipoParcela === 1}
                onChange={(e) => this.obs.filtro_tipo = e.target.value}
                value={this.obs.filtro_tipo}
              >
                <option value="">Todas</option>

                {this.tiposParcelasCategoria[this.obs.filtro_tipoParcela].map((item) => (

                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleBuscar}
            >
              Buscar
            </MDBBtn>
          </MDBCol>

        </MDBRow>

        <MDBRow>
          <MDBCol xl="12" lg="12" md="12" sm="12" xs="12" className="btns-Drop">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => RelatorioParcelamentoStore.obs.open_initial = true}
              style={{ float: "left" }}
            >
              Solicitar Relatório Parcelamentos
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={RelatorioParcelamentoStore.obs.tasks_relatorio}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataFormat={razaoSocialFormatter} dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="15%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Relatório</TableHeaderColumn>
            <TableHeaderColumn dataField="situacao_parcelamento" width="15%">Situação</TableHeaderColumn>
            <TableHeaderColumn dataField="categoria" dataFormat={categoriaFormatter} width="15%">Categoria</TableHeaderColumn>
            <TableHeaderColumn dataField="tipo" dataFormat={tipoFormatter} width="25%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={RelatorioParcelamentoStore.obs.length_tasks_relatorio}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <Dialog
          isOpen={RelatorioParcelamentoStore.obs.open_initial}
          onClose={() => this.onClose()}
          className="AlertUserParcelamentos"
        >
          <h2 className="titleSEFAZ">Configurações Relatório</h2>
          <FormGroup
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e) => {
                this.obs.modal_empresa = e;
              }}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextModal}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>
          </FormGroup>

          <MDBRow>
            <MDBCol md="3">
              <FormGroup
                label="Categoria parcelamento"
                className="nz-horizontal-field selectFullWidth"
                style={{ width: "100%" }}
              >
                <select
                  value={this.obs.modal_tipo_parcela}
                  onChange={(e) => this.handleChangeCategoriaParcelasModal(e.target.value)}
                  className="bp3-button bp3-align-left"
                >
                  <option value={0}>Todas</option>
                  <option value={1}>PGFN</option>
                  <option value={2}>RECEITA FEDERAL</option>
                  <option value={3}>ESPECIAIS</option>
                  <option value={4}>SIMPLES NACIONAL</option>
                  <option value={5}>SEFA</option>
                </select>
              </FormGroup>
            </MDBCol>
            <MDBCol md="9">
              <FormGroup
                label="Tipo parcelamento"
                className="nz-horizontal-field selectFullWidth"
                style={{ width: "100%" }}
              >
                <select
                  className="bp3-button bp3-align-left"
                  disabled={this.obs.modal_tipo_parcela === 0 || this.obs.modal_tipo_parcela === 1}
                  onChange={(e) => { this.obs.modal_tipo = e.target.value }}
                  value={this.obs.modal_tipo}
                >
                  <option value="">Todas</option>
                  {this.tiposParcelasCategoria[this.obs.modal_tipo_parcela].map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </MDBCol>
            <MDBCol md="3">
              <FormGroup
                label="Situação parcelamento"
                className="nz-horizontal-field selectFullWidth"
                style={{ width: "100%" }}
              >
                <select
                  className="bp3-button bp3-align-left"
                  onChange={(e) => this.obs.modal_situacao = e.target.value}
                  value={this.obs.modal_situacao}
                >
                  <option value={"Todas"}>Todas</option>
                  <option value={"Encerrado"}>Encerrado</option>
                  <option value={"Pendente"}>Pendente</option>
                  <option value={"Atrasado"}>Atrasado</option>
                  <option value={"Indisponível"}>Não Encontrado</option>
                </select>
              </FormGroup>
            </MDBCol>
            {/* <MDBCol md="6">
              <FormGroup
                label="Período de Solicitação"
                className="inputsPeriodoCalculos"
                style={{ width: "100%" }}
              >
                <DateRangePicker
                  onChange={this.handleDateSolicitacaoChange}
                  value={this.obs.date_periodo_relatorio}
                />
              </FormGroup>
            </MDBCol> */}
          </MDBRow>

          <button
              onClick={() => this.handleOpenParcelamentos()}
              style={{ padding: 0, border: "none", background: "none", fontWeight: "bold", textDecoration: "underline", color: "#3579ea", textAlign: "left", width: "max-content" }}
            >
              {"Acessar painel de parcelamentos para criação de solicitação"}
          </button>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateRelatorio()} />
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          isOpen={RelatorioParcelamentoStore.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
        >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
            {this.obs.erros_relatorio.length &&
              <div className="errosSped">
                <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                </BootstrapTable>
              </div>
            }
          </MDBCol>
        </Alert>

        <LoadingModal open={RelatorioParcelamentoStore.obs.loading} onClose={() => RelatorioParcelamentoStore.obs.loading = false} title={"Baixando arquivo"} />
      </>
    )
  }
}

export default RelatorioParcelamentoPage;
